/**
 * Site imagery (home, work, about). Unsplash placeholders — swap `src` for client-supplied
 * photos when available. Service card images reuse HERO_IMAGES.
 */
import WORK_SHOTS from '@/data/workShots.json';

const u = (id, w = 1400) => `https://images.unsplash.com/${id}?w=${w}&q=80&auto=format&fit=crop`;

export const HOME_HERO_IMAGE = {
  src: u('photo-1558591710-4b4a1ae0f04d', 1600),
  alt: '',
};

export const STUDIO_IMAGE = {
  src: u('photo-1522071820081-009f0129c71c'),
  alt: 'studio team working together at laptops',
};

// Keyed by WORK slug: the first real screenshot of each project.
export const WORK_IMAGES = Object.fromEntries(
  Object.entries(WORK_SHOTS).map(([slug, shots]) => [slug, { src: shots[0].src, alt: shots[0].label }])
);

export const ABOUT_IMAGE = {
  src: u('photo-1521737604893-d14cc237f11d', 1800),
  alt: 'NioDelta designers and engineers in a planning session',
};
